<template>
  <div class="kpis">
    <StatisticsKpi label="Groupes" :value="integer(k.groups)" hint="Hors groupes techniques" />
    <StatisticsKpi label="Utilisateurs" :value="integer(k.users)" :hint="`${integer(k.waitingUsers)} en attente de groupe`" />
    <StatisticsKpi label="Groupes actifs" :value="integer(k.activeGroups30d)" :hint="`${percent(activeShare)} des groupes, sur 30 jours`" :tone="k.groups && !k.activeGroups30d ? 'warn' : ''" />
    <StatisticsKpi label="Utilisateurs actifs" :value="integer(k.activeUsers30d)" hint="Connectés dans les 30 derniers jours" />
    <StatisticsKpi label="Connexions (7 jours)" :value="integer(k.connections7d)" hint="Sept derniers jours glissants" />
    <StatisticsKpi label="Connexions (30 jours)" :value="integer(k.connections30d)" hint="Trente derniers jours glissants" />
  </div>
  <div class="charts">
    <StatisticsCard :span="7" title="Connexions par jour" subtitle="Trente derniers jours, groupes clients uniquement" :empty="!hasData(data.series.map(row => row.connections))">
      <StatisticsChart :labels="data.series.map(row => shortDay(row.day))" :datasets="connectionDatasets" value-format="integer" />
    </StatisticsCard>
    <StatisticsCard :span="5" title="Options des groupes" subtitle="Nombre de groupes qui ont chaque option" :empty="!data.options.length">
      <StatisticsChart horizontal :legend="false" :height="optionsHeight" value-format="integer" :labels="options.map(option => option.title)" :datasets="[{label: 'Groupes', data: options.map(option => option.groups)}]" />
    </StatisticsCard>
  </div>
</template>

<script>
import StatisticsKpi from "@/statistics/components/StatisticsKpi.vue";
import StatisticsCard from "@/statistics/components/StatisticsCard.vue";
import StatisticsChart from "@/statistics/components/StatisticsChart.vue";
import {hasData, integer, percent} from "@/statistics/utils/format";
import {PALETTE} from "@/statistics/utils/chartTheme";
import {shortDay} from "@/administration/utils";

/**
 * Synthèse : les chiffres clés des groupes clients, leurs connexions dans le temps et la répartition des options.
 */
export default {
  name: 'OverviewStats',
  components: {StatisticsKpi, StatisticsCard, StatisticsChart},
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    k() {
      return this.data.kpis;
    },
    activeShare() {
      return this.k.groups ? this.k.activeGroups30d / this.k.groups * 100 : 0;
    },
    connectionDatasets() {
      return [
        {label: 'Connexions', data: this.data.series.map(row => row.connections), color: PALETTE[0]},
        {label: 'Utilisateurs actifs', data: this.data.series.map(row => row.activeUsers), type: 'line', color: PALETTE[2]},
      ];
    },
    // Les options les plus répandues d'abord
    options() {
      return [...this.data.options].sort((a, b) => b.groups - a.groups);
    },
    optionsHeight() {
      return `${Math.max(180, this.options.length * 34 + 40)}px`;
    },
  },
  methods: {integer, percent, hasData, shortDay},
};
</script>

<style lang="stylus" scoped>
@require '~/src/statistics/style/statistics.styl';
</style>
